import { reactionOptions } from "app/constants/options"
import { Reaction, ReactionType, postReactions } from "app/types"

interface ReactionDoc {
  id: string
  reaction: ReactionType
  user: {
    id: string
  }
}

const reactionLabelMap: Record<ReactionType, string> = {
  'like': 'Liked',
  'love': 'Love',
  'haha': 'Happy',
  'sad': 'Sad',
  'angry': 'Angry',
}

const reactionColorMap: Record<ReactionType, string> = {
  'like': '#05C8C8',
  'angry': '#DB4324',
  'haha': '#46A758',
  'love': '#E93D82',
  'sad': '#0091FF',
}

export const formatReactions = (reactionDocs: ReactionDoc[]): Reaction[] => {
  const docs = reactionDocs || []
  const reactions = postReactions
    .map((item) => ({
      name: item,
      icon: reactionOptions[item],
      label: reactionLabelMap[item],
      color: reactionColorMap[item],
      userId: docs.find((reaction) => reaction.reaction === item)?.user.id || '',
      count:
        docs.filter((reaction) => reaction.reaction === item)
          .length || 0,
    }))
    .filter((r) => r.count > 0) || []


  return reactions
}